import {
    LOGIN,
    LOGOUT,
    WXLOGIN,
    SETTLE,
	SELECTADDRESS,
    REMOVEADDRESS,
    SELECTBANK,
	REMOVEBANK,
    SELECTINVOICE,
	REMOVEINVOICE
} from ".././mutation_types";

// localStorage 保存数据时间更久，不会因为关闭标签而丢失

const state = {
    user_id: localStorage.getItem("user_id") || 0,
    role: localStorage.getItem("role") || 0,
    user_name: localStorage.getItem("user_name") || "未登录",
    token: localStorage.getItem("token") || "",
    uuid: localStorage.getItem("uuid") || "",
    shop_settle: localStorage.getItem("shop_settle") || "",
    select_address: localStorage.getItem("select_address") || "",
	select_bank: localStorage.getItem("select_bank") || "",
    select_invoice: localStorage.getItem("select_invoice") || "",
};

const getters = {
    user_id: state => {
        return state.user_id;
    },
    role: state => {
        return state.role;
    },
    user_name: state => {
        return state.user_name;
    },
    token: state => {
        return state.token;
    },
    uuid: state => {
        return state.uuid;
    },
    shop_settle: state => {
        return state.shop_settle;
    },
    select_address: state => {
        return state.select_address;
    },
    select_bank: state => {
        return state.select_bank;
	},
    select_invoice: state => {
        return state.select_invoice;
    }
};

const mutations = {
    [WXLOGIN](state, data) {
        localStorage.setItem("openId", data.openId); // 设置localStorage
        state.openId = data.openId;
    },
    [LOGIN](state, data) {
        // localStorage.setItem("user_id", data.id); // 设置localStorage
        // localStorage.setItem("role", data.role);
        localStorage.setItem("user_name", data.name);
        localStorage.setItem("token", data.token);
        localStorage.setItem("uuid", data.uuid);
        // state.user_id = data.id;
        // state.role = data.role;
        state.user_name = data.name;
        state.token = data.token;
        state.uuid = data.uuid;
    },
    [LOGOUT](state) {
        // localStorage.removeItem("user_id"); //移除localStorage
        // localStorage.removeItem("role");
        // localStorage.removeItem("user_name");
        localStorage.removeItem("token");
        localStorage.removeItem("uuid");
        localStorage.removeItem('senddingzhiArr');  // 已发送我要定制的数组
        // localStorage.removeItem("code");
        // state.user_id = 0;
        // state.role = 0;
        // state.user_name = "";
        state.token = "";
        state.uuid = "";
    },
    [SETTLE](state, data) {
        localStorage.setItem("shop_settle", data.shop_settle); // 设置localStorage
        state.shop_settle = data.shop_settle;
    },
    [SELECTADDRESS](state, data) {
        localStorage.setItem("select_address", data.select_address); // 设置localStorage
        state.select_address = data.select_address;
	},
	[REMOVEADDRESS](state) {
        localStorage.removeItem("select_address");
        state.select_address = '';
    }, 
    [SELECTBANK](state, data) {
        localStorage.setItem("select_bank", data.select_bank); // 设置localStorage
        state.select_bank = data.select_bank;
	},
	[REMOVEBANK](state) {
        localStorage.removeItem("select_bank");
        state.select_bank = '';
	},
    [SELECTINVOICE](state, data) {
        localStorage.setItem("select_invoice", data.select_invoice); // 设置localStorage
        state.select_invoice = data.select_invoice;
	},
	[REMOVEINVOICE](state) {
        localStorage.removeItem("select_invoice");
        state.select_invoice = '';
	}
}

export default {
    state,
    mutations,
    getters
}
